<template lang="pug">
k-page.post.contact
  d-main-image( v-bind=`{ img, show }` @load='pageLoaded' )
  w-go-down
  k-main( :title='title' )
</template>

<script lang="js">
import _wpapix from '@/lib/wpapix'
import KPage from '@/blocks/k-page'
import KMain from '@/blocks/k-main'
import DMainImage from '@/displays/d-main-image'
import WGoDown from '@/widgets/w-go-down'
import { User, Page } from '@/mixins'

export default {
  name: 'MemberConfirmPage',
  mixins: [ User, Page ],
  components: { KPage, KMain, DMainImage, WGoDown },
  props: {},
  data() {
    return {
      membership: false,
      img: '',
      show: false
    }
  },
  created() {},
  mounted() {
    window.close()
    _wpapix.then( wpapix => {
      var membership = new wpapix.Membership({ path: 'my-level' })
      membership.fetch().done( res => {
        this.sstate.user.membership = res
        this.membership = res
      })
    })
  },
  methods: {
    showImg() {}
  },
  computed: {}
}
</script>

<style lang="scss">
.member-confirm {

}
</style>
